// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAddAccountApiParameter, customAddAccountService } from "@ces/App/Services/CreateAccountService";
import {
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    AddAccount,
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";

export const XngAddAccount: typeof AddAccount = async props => {
    stopWatchingForOtherTabSessionChange();
    (props.apiResult as ServiceResult<{}>) = await customAddAccountService(
        props.apiParameter?.account as CustomAddAccountApiParameter,
    );
    watchForOtherTabSessionChange();
};

export const XngExecuteOnSuccessCallback: typeof AddAccount = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);

        (props.parameter.onSuccess as (result: any) => void)?.(props.apiResult);
    }
};

replaceInChain(chain, AddAccount, XngAddAccount);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
